// namespace
export const USER_NAMESPACE = 'user'

// actions
export const USER_ACTION_DELETE_ACCOUNT = 'deleteUserAccount'



// WEBPACK FOOTER //
// ./src/store/modules/user-types.js